import { styled, Skeleton } from '@mui/material';

export const StyledSkeleton = styled(Skeleton)(() => ({
  transform: 'none',
  display: 'block',
  width: '100%'
}));
